module.exports = __webpack_public_path__ + "static/media/youtube.e16442b6.svg";